import { c as _c } from "react/compiler-runtime";
interface DermatologyIconProps {
  size?: number;
  className?: string;
}
const DermatologyIcon = t0 => {
  const $ = _c(9);
  const {
    size: t1,
    className: t2
  } = t0;
  const size = t1 === undefined ? 18 : t1;
  const className = t2 === undefined ? "" : t2;
  const t3 = `dynamic-size ${className}`;
  let t4;
  if ($[0] !== size) {
    t4 = {
      "--width": size,
      "--height": size
    };
    $[0] = size;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = t4 as React.CSSProperties;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path d="M14.4736 2.95007C17.0095 2.93573 19.412 3.93803 21.2295 5.77332C23.0467 7.60847 24.0484 10.0391 24.0498 12.6171C24.0511 15.5882 22.7368 18.353 20.4434 20.202C20.0649 20.5078 19.9019 21.0174 20.0293 21.5009L20.7812 24.3456C20.8592 24.6428 20.6858 24.9499 20.3916 25.0302L20.3193 25.0448C20.2953 25.048 20.2715 25.0497 20.248 25.0497V25.0487C20.0047 25.0482 19.7828 24.8836 19.7168 24.6346L18.9658 21.7899C18.725 20.8769 19.0355 19.91 19.7588 19.326C21.7871 17.6911 22.9496 15.2451 22.9482 12.6171C22.9468 10.3386 22.0614 8.18986 20.4531 6.56628C18.8448 4.94208 16.7211 4.05716 14.4814 4.06921C9.86978 4.09689 6.11528 7.93249 6.11523 12.6219C6.11524 12.973 6.13561 13.3235 6.17676 13.663C6.19288 13.7927 6.16314 13.924 6.09375 14.0341V14.035L4.06445 17.2294V17.2303C4.0523 17.2497 4.05123 17.2662 4.06152 17.286V17.287C4.06546 17.2947 4.07143 17.3014 4.07812 17.3065C4.08432 17.3112 4.0937 17.3159 4.1084 17.3163L5.9043 17.3671C6.20337 17.3761 6.44043 17.6245 6.44043 17.9266V22.2225C6.44055 22.6691 6.72069 23.0753 7.13574 23.2343C8.37037 23.7042 10.4041 24.0321 13.0674 22.9169C13.3495 22.7994 13.6722 22.9361 13.7881 23.2216C13.9038 23.5067 13.7699 23.8339 13.4883 23.952C10.497 25.2047 8.17205 24.8241 6.74707 24.2821C5.90344 23.96 5.33792 23.1321 5.33789 22.2225V18.4706L4.07617 18.4354C3.65209 18.4233 3.28069 18.1871 3.08398 17.8065C2.8882 17.4268 2.90821 16.9843 3.1377 16.6249L5.06055 13.5956C5.02885 13.2759 5.01173 12.9497 5.01172 12.6229C5.01172 10.0498 5.99589 7.62707 7.78125 5.80261C9.56594 3.9782 11.9427 2.96515 14.4736 2.95007Z" fill="currentColor" />;
    t7 = <circle cx="14.75" cy="18.7501" r="0.75" fill="currentColor" />;
    t8 = <circle cx="11.7502" cy="18.7501" r="0.75" fill="currentColor" />;
    t9 = <circle cx="15.65" cy="15.65" r="0.65" fill="currentColor" />;
    $[2] = t6;
    $[3] = t7;
    $[4] = t8;
    $[5] = t9;
  } else {
    t6 = $[2];
    t7 = $[3];
    t8 = $[4];
    t9 = $[5];
  }
  let t10;
  if ($[6] !== t3 || $[7] !== t5) {
    t10 = <svg className={t3} style={t5} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" fill="none">{t6}{t7}{t8}{t9}</svg>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  return t10;
};
export default DermatologyIcon;